import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign(Object.assign({}, getTestId('ContactDetailFormWidget')), {
  numberLabel: 'Mobile number',
  numberInputRegex: '^[6-9]{1}[0-9]*$',
  numberValidationRegex: '^\\d{10}$',
  numberMaxLength: 10,
  nameLabel: 'Name',
  nameValidationRegex: '^[a-zA-Z]{3,}$',
  buttonText: 'Proceed',
  isButtonDisabled: true,
  buttonOnPressMetaData: {
    id: 'CTA'
  }
});